import { render, staticRenderFns } from "./CorrectScore.vue?vue&type=template&id=66cc9012&"
import script from "./CorrectScore.vue?vue&type=script&lang=js&"
export * from "./CorrectScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports